var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-container"},[_c('iframe',{ref:"iframeRef",staticClass:"content-iframe",attrs:{"src":_vm.iframeSrc,"allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }